import React, { useEffect, useState } from 'react';
import "./AddRecord.scss"

import ModalComponent from '../../UI/ModalComponent/ModalComponent';
import RecordFormMain from '../RecordForm/RecordFormMain/RecordFormMain';

const AddRecord = () => {
	const [modalOpen, setModalOpen] = useState(null)

	const closeModal = () => {
		setModalOpen(false)
	}

	return (
		<div className="add-record">
			<ModalComponent
				isOpen={modalOpen}
				isRecordModal={true}
				button={<div className="add-record__button"></div>}>
				<RecordFormMain callbackFunction={closeModal}/>
			</ModalComponent>
		</div>
	);
};

export default AddRecord;
